import type { RiskTagProps } from "./risk-tag.type";

import { riskDisplayLabel } from "@/modules/risk";
import { Tag } from "@/ui/tag";

export const RiskTag = ({ risk, ...tagProps }: RiskTagProps) => {
  if (!risk) return null;

  return (
    <Tag {...tagProps} variant="solid" color={risk.color}>
      {riskDisplayLabel(risk)}
    </Tag>
  );
};
